/** Ensure img/Image can load stored part art (fixes raw base64 → GET /iVBOR… 431). */
export function normalizeImageDataUrl(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return trimmed;
  if (trimmed.startsWith("data:") || trimmed.startsWith("blob:")) return trimmed;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  const base64 = trimmed.includes(",") ? trimmed.split(",").pop()!.trim() : trimmed;
  if (!base64 || !/^[A-Za-z0-9+/=\s]+$/.test(base64)) return trimmed;

  const compact = base64.replace(/\s/g, "");
  const mime = compact.startsWith("/9j/") ? "image/jpeg" : "image/png";
  return `data:${mime};base64,${compact}`;
}

export function imageDataUrlForDisplay(value: string): string {
  return normalizeImageDataUrl(value);
}

export function imageDataUrlForStorage(value: string): string {
  return normalizeImageDataUrl(value);
}
